<template>
    <a href="javascript:void(0)" data-toggle="modal" data-target="#mwl-lab-contacts-modal" v-if="contacts.length > 0">
        <span class="fa fa-question"></span>

        <span id="mwl-lab-contacts">
            <span>
                {{ label }}
            </span>

            <!-- START MODAL -->
            <div class="modal fade" id="mwl-lab-contacts-modal" ref="modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">

                        <div class="modal-header">
                            <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                            <h4 class="modal-title">Midwest Laboratories Contacts</h4>
                        </div>

                        <div class="modal-body">
                            <div class="mwl-contact p-10 clearfix" v-for="contact in contacts">
                                <div class="pull-left name-title">
                                    <div class="mwl-contact-name">{{ contact.name }}</div>
                                    <div>{{ contact.title }}</div>
                                </div>
                                <div class="pull-right phone-email">
                                    <a :href="'tel:' + contact.phone ">
                                        <i class="fa fa-phone"></i>
                                        {{ contact.phone }}
                                    </a>
                                    <a :href="'mailto:' + contact.email">
                                        <i class="fa fa-envelope"></i>
                                        {{ contact.email }}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal" aria-label="Close" aria-hidden="true">
                                <i class="fa fa-close"></i>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END MODAL -->
        </span>
    </a>
</template>

<style lang="scss" scoped>
    @import '../../sass/_global_variables.scss';

    #mwl-lab-contacts {
        .btn.text {
            i {
                zoom: 1.25;
            }
        }
    }

    #mwl-lab-contacts-modal {
        .mwl-contact {
            &:not(:last-child) {
                border-bottom: 1px solid $border-gray;
             }

            .mwl-contact-name {
                font-weight: bold;
                font-size: 1.5em;
            }

            a {
                display: block;

                i {
                    width: 15px;
                    margin-right: 5px;
                }
            }

            .name-title {
                width: 315px;
                padding-right: 25px;
            }

            .phone-email {
                width: 220px;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            label: { default: 'Need Assistance' },
            show_icon: { default: true },
            contacts: { default () { return [] }}
        },
        data () {
            return {
                modal: null
            }
        },
        watch: {},
        methods: {},
        mounted () {
            this.modal = $(this.$refs.modal)
            $('body').append(this.modal)
        }
    }
</script>


// WEBPACK FOOTER //
// mwl-lab-contacts.vue?2f68398c